module.exports = __webpack_public_path__ + "img/logo_lcfw.3a70614c.png";